"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(_ref) {
  var ariaLabel = _ref.ariaLabel,
      classes = _ref.classes,
      clickMethod = _ref.clickMethod,
      dataTestId = _ref.dataTestId,
      href = _ref.href,
      isFullWidth = _ref.isFullWidth,
      size = _ref.size,
      target = _ref.target,
      text = _ref.text,
      variant = _ref.variant;
  return /*#__PURE__*/_react.default.createElement("a", {
    id: dataTestId,
    className: (0, _classnames.default)('cta', "cta--".concat(variant), {
      'cta--small': size === 'small',
      'cta--full-width': isFullWidth
    }, classes),
    "data-testid": dataTestId,
    href: href,
    target: target,
    rel: target === '_blank' ? 'noopener noreferrer' : null,
    "aria-label": ariaLabel,
    onClick: clickMethod
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "cta__label"
  }, text));
};

Link.propTypes = {
  /**
   Optional. Customizes the aria-label value.
   */
  ariaLabel: _propTypes.default.string,

  /**
   Optional. Allows the component to accept custom classes.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Used if some JavaScript function must be called prior to taking the user to the target URL.
   */
  clickMethod: _propTypes.default.func,

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios.
   */
  dataTestId: _propTypes.default.string,

  /**
   Required. The URL for the href attribute.
   */
  href: _propTypes.default.string.isRequired,

  /**
   Optional. Gives the button a width of 100% of it's container.
   */
  isFullWidth: _propTypes.default.bool,

  /**
   Optional. Link size options: 'small', 'large'. Defaults to 'large'.
   */
  size: _propTypes.default.oneOf(['small', 'large']),

  /**
   Optional. Changes browser window behavior for href. Options: '_blank', '_parent', '_self', '_top'. Defaults to null.
   */
  target: _propTypes.default.oneOf(['_blank', '_parent', '_self', '_top']),

  /**
   Required.
   */
  text: _propTypes.default.string.isRequired,

  /**
   Optional. Link variant options: 'primary', 'secondary', 'alternate', 'text-primary', 'text-secondary'. Defaults to 'text-primary'.
   */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'alternate', 'text-primary', 'text-secondary'])
};
Link.defaultProps = {
  ariaLabel: null,
  classes: '',
  clickMethod: null,
  dataTestId: '',
  target: null,
  isFullWidth: false,
  variant: 'text-primary',
  size: 'large'
};
var _default = Link;
exports.default = _default;